<template>
  <transition name="pa-simple-fade">
    <section class="pa-connection-private-no-pod-view" v-if="couldVisibleNoPodList">
      <div class="large-icon-set">
        <div class="large-icon">
          <IconLogo />
        </div>
        <div class="title-field">
          <p class="text">マイポット</p>
          <p class="splash-title-bottom-line">
            <SplashTitleBottom class="splash-title-bottom-line" />
          </p>
        </div>
      </div>

      <div class="message-set">
        <div class="parag">
          <p>塔経市帝は様々な異世界をつなぐ</p>
          <p>異世界のるつぼ</p>
        </div>

        <div class="parag">
          <p>異なる価値観を投入して</p>
          <p>混ぜ合わせれば新しい何かが生まれる。</p>
        </div>

        <div class="parag">
          <p>マイポットの中で</p>
          <p class="strong">新しい繋がりを錬成しましょう。</p>
        </div>

        <div class="parag parag-recipe">
          <div class="pa-title">
            <TokeiCityStyleLogo class="city-style" />
            <p class="text-title">〜&nbsp;マイポットの作り方&nbsp;〜</p>
          </div>
          <div class="pa-sub-title">
            <div class="pa-text">材料</div>
            <div class="line">
              <hr class="pa-hr" />
            </div>
          </div>
          <div class="pa-ingredient-line">
            <div class="name">きなこきびだんご</div>
            <div class="quanty">１個</div>
          </div>
          <div class="pa-ingredient-line">
            <div class="name">きびだんご</div>
            <div class="quanty">人数分</div>
          </div>
          <div class="pa-ingredient-line">
            <div class="name">異界渡航者</div>
            <div class="quanty">８名まで</div>
          </div>
          <div class="pa-ingredient-line">
            <div class="name">相互理解</div>
            <div class="quanty">大さじ一杯</div>
          </div>
          <div class="pa-ingredient-line">
            <div class="name">期待と希望</div>
            <div class="quanty">少々</div>
          </div>
          <div class="pa-sub-title pa-sub-title-bottom">
            <div class="pa-text">作り方</div>
            <div class="line">
              <hr class="pa-hr" />
            </div>
          </div>
          <div class="pa-step-line">
            <p><span>①</span>きなこきびだんごを使用して新しいメルティングポットを入手します。</p>
          </div>
          <div class="pa-step-line">
            <p><span>②</span>リズミカルにかき混ぜて、頃合いを見計らいながら材料を投入していきます。</p>
          </div>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
import {GetPodRoomList} from '@/graphql/queries/ConnectionPod.graphql'

import IconLogo           from '@/components/Pages/Connections/ConnectionApp/Images/icon_logo.svg?inlineN'
import SplashTitleBottom  from '@/components/Pages/Connections/ConnectionApp/Images/splash_title_bottom.svg?inlineN'
import TokeiCityStyleLogo from '@/components/Pages/Connections/ConnectionApp/Images/tokei-city-style-logo.svg?inlineN'

export default {
  components : {
    IconLogo,
    SplashTitleBottom,
    TokeiCityStyleLogo
  },

  computed : {
    podRoomType(){
      return this.$store.state.connection.podRoomType;
    },

    podRoomId(){
      return this.$store.state.connection.podRoomId[this.podRoomType];
    },

    couldVisibleNoPodList(){
      if(
        (typeof this.joinedPodRoomList !== 'undefined') &&
        (this.podRoomType === 'private') && (this.joinedPodRoomList.length === 0)
      ){
        return true;
      }else{
        return false;
      }
    }
  },

  apollo : {
    joinedPodRoomList : {
      query : GetPodRoomList,
      variables(){
        return {
          roomType  : this.podRoomType
        };
      },
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-connection-private-no-pod-view{
  margin-top:.5rem !important;
  background-repeat: no-repeat;
  background-position: 50% 8%;
  background-size:120%;
  background-image: url('~@/components/Pages/Connections/ConnectionApp/Images/connections-background.svg');
  overflow: hidden;
  user-select: none;
  border:0;
  padding-bottom:1rem;

  @media screen and (min-width: $desktop) {
    background-size:100%;
  }

  .large-icon-set{
    padding-top:.6rem;

    @media screen and (min-width: $desktop) {
      padding-top:24px;
    }

    div.large-icon{
      text-align: center;
      svg{
        width:28%;
        max-width:28%;

        @media screen and (min-width: $desktop) {
          max-width:100px;
        }
        
        .a{
          fill:none;
        }
        
        .b{
          fill:#7f4f16;
        }
      }
    }

    div.title-field{
      margin-top:.3rem;
      text-align: center;

      p{
        font-weight: bold;
        color:#7F4F16;
        font-size: 1.4rem;

        &.splash-title-bottom-line{
          font-size: 0;
        }

        &.text{
          margin:0;
          padding:0;
          line-height: 1.6rem;
        }
      }

      svg.splash-title-bottom-line{
        margin-top:.15rem;
        width:38vw;
      }

      @media screen and (min-width: $desktop) {
        margin-top:8px;

        p{
          font-size:1.8rem;
        }

        svg.splash-title-bottom-line{
          margin-top:6px;
          width:260px;
        }
      }
    }
  }

  .message-set{
    margin-top:.5rem;
    font-family: 'mplus-1m-regular';

    p{
      text-align: center;
      font-size:1.13rem;
      color:#7F4F16;
    }

    div.parag{
      margin-top:.5rem;
      text-align: center;

      &-strong{
        font-family: 'mplus-1m-medium';
      }

      &-button{
        padding-bottom:.5rem;
      }

      p.strong{
        font-family: 'mplus-1m-medium';
      }
    }

    .button{
      text-align: center;
      margin:0 auto;
      padding:.2rem;
      font-size:1rem;
      color:#D2BA9E;
      background-color:#8E5B17;
      border:2px solid #7F4F16;
      height:inherit;
    }

    @media screen and (min-width: $desktop) {
      margin-top:12px;

      p{
        font-size:1.5rem;
        margin-top:1rem;
        margin-bottom:1rem;
      }

      div.parag{
        margin-top:10px;

        &-button{
          margin-bottom: 18px;
        }
      }

      a.button{
        padding:.2rem 2rem;
        font-size:1.2rem;
      }
    }
  }

  .parag-recipe{
    background-color:#CCA87C;
    width:98%;
    margin:.5rem auto 0;
    border-radius: 10px;
    padding-bottom:.5rem;
    
    .pa-title{
      padding:.6rem 0 .5rem;

      svg.city-style{
        width:38%;

        .a{
          fill:#c69963;
        }
        
        .b{
          fill:#7f4f16;
        }
      }

      .text-title{
        font-family: 'mplus-1m-medium';
        line-height: 1;
        font-size: 1.3rem;
      }
    }

    .pa-sub-title{
      display: flex;
      flex-direction: row;
      width:95%;
      margin:0 auto .7rem;

      .pa-text{
        width:19%;
        font-family: 'mplus-1m-medium';
        color: #7F4F16;
        font-size:1.2rem;
        line-height: 1;
        text-align:left;
      }

      .line{
        width:81%;

        hr.pa-hr{
          margin:.3rem 0 0;
          background-color: #7F4F16;
          height:2.5px;
        }
      }

      &-bottom{
        margin-top:.8rem;
        margin-bottom:.5rem;

      .line{
        hr.pa-hr{
          height:2.8px;
        }
      }
      }
    }

    .pa-ingredient-line{
      display: flex;
      flex-direction: row;
      width:95%;
      margin:.6rem auto 0;
      font-family: 'mplus-1m-medium';
      color: #7F4F16;
      font-size:1.1rem;
      line-height: 1;
      
      .name{
        width:50%;
        text-align: left;
      }

      .quanty{
        width:50%;
        text-align: right;
      }
    }

    .pa-step-line{
      width:95%;
      margin:.4rem auto 0;

      p{
        font-family: 'mplus-1m-medium';
        color: #7F4F16;
        font-size:1.1rem;
        line-height: 1.3;
        text-align:left;
      }
    }
  }
}
</style>